import BlockComponentImage from '../../../models/BlockComponentValues/BlockComponentImage';
import BlockComponentText from '../../../models/BlockComponentValues/BlockComponentText';

export interface BlockAnimationWithImageDescriptionData {
  title: BlockComponentText;
  imgLeft: BlockComponentImage,
  imgRight: BlockComponentImage,
  imgLeftDesc: BlockComponentText,
  imgRightDesc: BlockComponentText,
  text1: BlockComponentText,
  text2: BlockComponentText,
}

// eslint-disable-next-line @typescript-eslint/no-namespace
export namespace BlockAnimationWithImageDescriptionData {
  interface MakeProps {
    title: string,
    imgLeftUrl: string
    imgRightUrl: string
    imgLeftDesc: string
    imgRightDesc: string
    text1: string
    text2: string
  }

  export const make = (props: MakeProps): BlockAnimationWithImageDescriptionData => {
    const {
      title, imgLeftUrl, imgRightUrl, imgLeftDesc, imgRightDesc, text1, text2,
    } = props;
    return {
      title: BlockComponentText.make(title),
      imgLeft: BlockComponentImage.make(imgLeftUrl),
      imgRight: BlockComponentImage.make(imgRightUrl),
      imgLeftDesc: BlockComponentText.make(imgLeftDesc),
      imgRightDesc: BlockComponentText.make(imgRightDesc),
      text1: BlockComponentText.make(text1),
      text2: BlockComponentText.make(text2),
    };
  };

  export const getDefault = (defaultImageUrl = ''): BlockAnimationWithImageDescriptionData => {
    const defaultTitle = '<p><strong style="font-size: 36px;">見出し</strong></p>';
    const defaultText = 'ここをクリックして表示したいテキストを入力してください。テキストは「太字」「文字サイズ」など編集することができます。';
    const defaultDescription = 'テキストを入力してください';
    return {
      title: BlockComponentText.make(defaultTitle),
      imgLeft: BlockComponentImage.make(defaultImageUrl),
      imgRight: BlockComponentImage.make(defaultImageUrl),
      imgLeftDesc: BlockComponentText.make(defaultDescription),
      imgRightDesc: BlockComponentText.make(defaultDescription),
      text1: BlockComponentText.make(defaultText),
      text2: BlockComponentText.make(defaultText),
    };
  };
}
